import { createReducer , on } from '@ngrx/store';
import { ProfessionalsJSONRes } from 'src/app/models';
import { getProfessionalsJsonActionSuccess } from '../../actions/professionals/professionals-actions';

export interface ProfessionalsJsonState {
    professionalsJson : ProfessionalsJSONRes;
}

const initialState : ProfessionalsJSONRes = new ProfessionalsJSONRes();  

export const ProfessionalsJsonReducer = createReducer(
    initialState,
    on( getProfessionalsJsonActionSuccess , (state , {professionalsJSONres}   ) => {
        return professionalsJSONres;
    })
)



